module.exports = __webpack_public_path__ + "img/a6.b43da245.png";